import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
// import Table from './Table'
import Pagination from "../../Pagination";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
// import Modal from './View'
import { BiArrowBack } from "react-icons/bi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "utils/helpers";
import { AiFillEye } from "react-icons/ai";

function SoldItemList({ userDetails }) {
  const { t } = useTranslation();
  const { logoutUser, user, updatePageName } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });

  const [sellItems, setSellItems] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [userData, setUserData] = useState(
    !isEmpty(location.state?.userDetails)
    ? location.state?.userDetails
    : userDetails
    );
  const [filterData, setFilterData] = useState({
    category: "",
    searchkey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sort_key: "createdAt",
    sort_type: "desc",
  });
  const manager = user?.permission?.find((e) => e.manager === "category") ?? {};

  const getAllPosts = async (data) => {
    try {
      const { category, searchkey, isFilter } = filterData;
      if (
        (data?.deletePage && !(sellItems?.length > 1)) ||
        (isFilter && category && data?.statusChange && !(sellItems?.length > 1))
      ) {
        if (!(sellItems?.length > 1)) {
          setPage(page - 1);
          setIsDelete(true);
          setPaginationObj({ ...paginationObj, page: page - 1 });
        }
      } else {
        setIsDelete(false);
      }
      const payload = {
        page,
        pageSize,
        status: category,
        keyword: searchkey,
        sortKey: sort.sort_key,
        sortType: sort.sort_type,
      };

      const path = apiPath.soldItemByUserId + "/" + userData?._id;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setSellItems(response?.docs);
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null,
        });
      }
    } catch (error) {
      console.log("error ", error);
      setPaginationObj({});
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };

  const toggleModal = (item) => {
    setShowModal(!showModal);
    setItem(item ?? {});
  };

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  useEffect(() => {
    getAllPosts();
  }, [page, filterData, sort]);

  const handleSearchKey = (e) => {
    setFilterData({ ...filterData, searchkey: e.target.value, isFilter: true });
    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      category: "",
      searchkey: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setIsDelete(true);
  };

  const statusPage = (e) => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true });
    setPage(1);
    setIsDelete(true);
  };
  return (
    <div>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <div className="p-3">
              <div className="overflow-x-auto relative rounded-lg border">
                <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                  <thead className="text-xs text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="py-3 px-6">
                        #
                      </th>
                      <th scope="col" className="py-3 px-6">
                        {t("O_ITEM_NAME")}
                      </th>
                      <th scope="col" className="py-3 px-6">
                        {t("O_ITEM_PRICE")} (৳)
                      </th>
                      <th scope="col" className="py-3 px-6">
                        {t("O_CATEGORY")}
                      </th>
                      <th scope="col" className="py-3 px-6">
                        {t("O_SUBCATEGORIES")}
                      </th>
                      <th scope="col" className="py-3 px-6">
                        {t("O_DESCRIPTION")}
                      </th>
                      <th
                        scope="col"
                        className="py-3 px-2 cursor-pointer"
                        onClick={() => {
                          if (
                            sort.sort_key === "createdAt" &&
                            sort.sort_type === "asc"
                          ) {
                            setSort({
                              sort_key: "createdAt",
                              sort_type: "desc",
                            });
                          } else {
                            setSort({
                              sort_key: "createdAt",
                              sort_type: "asc",
                            });
                          }
                        }}
                      >
                        <div className="flex justify-end">
                          <span>{t("O_CREATED_AT")}</span>
                          <span>
                            {sort.sort_key === "createdAt" &&
                              sort.sort_type === "asc" && (
                                <BsArrowUpShort className="w-4 h-4" />
                              )}
                            {sort.sort_key === "createdAt" &&
                              sort.sort_type === "desc" && (
                                <BsArrowUpShort className="w-4 h-4 rotate-180" />
                              )}
                          </span>
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="py-3 px-2 cursor-pointer"
                        onClick={() => {
                          if (
                            sort.sort_key === "updatedAt" &&
                            sort.sort_type === "asc"
                          ) {
                            setSort({
                              sort_key: "updatedAt",
                              sort_type: "desc",
                            });
                          } else {
                            setSort({
                              sort_key: "updatedAt",
                              sort_type: "asc",
                            });
                          }
                        }}
                      >
                        <div className="flex justify-end">
                          <span>{t("O_UPDATED_AT")}</span>
                          <span>
                            {sort.sort_key === "updatedAt" &&
                              sort.sort_type === "asc" && (
                                <BsArrowUpShort className="w-4 h-4" />
                              )}
                            {sort.sort_key === "updatedAt" &&
                              sort.sort_type === "desc" && (
                                <BsArrowUpShort className="w-4 h-4 rotate-180" />
                              )}
                          </span>
                        </div>
                      </th>
                      <th scope="col" className="py-3 px-6">
                        {t("O_ACTION")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sellItems &&
                      sellItems?.map((item, i) => (
                        <tr
                          key={i}
                          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                        >
                          <th
                            scope="row"
                            className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white"
                          >
                            {i + 1 + 10 * (page - 1)}
                          </th>
                          <td className="py-4 px-6 border-r">
                            {item?.itemName}
                          </td>
                          <td className="py-4 px-6 border-r">
                            {item?.itemPrice}
                          </td>
                          <td className="py-4 px-6 border-r">
                            {item?.categoryDetails?.title}
                          </td>
                          <td className="py-4 px-6 border-r">
                            {item?.subCategoryDetails?.title}
                          </td>
                          <td className="py-4 px-6 border-r">
                            {item?.description}
                          </td>
                          <td className="py-2 px-2 border-r text-right">
                            {helper.dateFormat(item?.createdAt)}
                          </td>
                          <td className="py-2 px-2 border-r text-right">
                            {helper.dateFormat(item?.updatedAt)}
                          </td>
                          {(manager?.add || user?.role === "admin") && (
                            <td className="py-4 px-6 border-l">
                              <div className="">
                                <ul className="flex justify-center">
                                  <Link
                                    title={t('O_VIEW')}
                                    className="text-danger ml-2"
                                    to="/users/sell-item/view"
                                    state={{ item, userDetails: userData }}
                                  >
                                    <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                                  </Link>
                                </ul>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    {isEmpty(sellItems) ? (
                      <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                        <td className="py-4 px-6 border-r" colSpan={9}>
                          {t("O_NO_RECORD_FOUND")}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
export default SoldItemList;
